import { get } from 'lodash'

export const getPromoCodeValue = state => get(state, 'promocode.codeValue')
export const getPromoCodeSessionId = state => get(state, 'promocode.sessionId')
export const getValidatedPromoCodes = state => get(state, 'promocode.validatedPromoCodes')
export const getPromoCodeError = state => get(state, 'promocode.errorMessage')
